import React, {useEffect} from 'react'
import { Button } from 'react-bootstrap'
import ReactGA from "react-ga";

const Apply = () => {
  useEffect(() => {
    ReactGA.initialize('G-0FEQG8PQKQ');
    ReactGA.pageview(window.location.pathname);
  }, []);
  const handleClick = () => {
    ReactGA.event({
      category: 'Button',
      action: 'Click',
      label: 'Ver programa'
    });
  }
  const handleClickClass = () => {
    ReactGA.event({
      category: 'Button',
      action: 'Click',
      label: 'Clases magistrales'
    });
  }
  const handleClickMaster = () => {
    ReactGA.event({
      category: 'Button',
      action: 'Click',
      label: 'Talleres extension'
    });
  }
  const handleClickPublic = () => {
    ReactGA.event({
      category: 'Button',
      action: 'Click',
      label: 'Talleres funcionarios publicos'
    });
  }
  return (
    <>
      <div className='px-4 mx-auto sm:max-w-xl md:max-w-full  md:px-24 lg:px-8 bg-fuchsia-900'>
        <div className='px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20 -mt-20'>
          <div className='max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12'>
            <h2 className='max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto'>
              <span className='relative inline-block'>
                <span className='relative text-white'>INSCRIPCIONES</span>
              </span>{' '}
            </h2>
          </div>
          <div className='grid row-gap-8 sm:row-gap-0 grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 -mt-5'>
            <div className='p-8 '>
              <div className='max-w-md text-center'>
                <div className='flex items-center justify-center'>
                  <img
                    src='/assets/ilustraciones/svg/clases_magistrales.svg'
                    alt='clases magistrales'
                  />
                </div>
                <Button
                    onClick={handleClickClass}
                  href='https://forms.gle/1FkeJZVAt3YAg9zs5'
                  target='_blank'
                  rel='noreferrer'
                  className='lg:px-14 px-2 py-4 md:-ml-0 -ml-5 font-medium transform bg-naranjo_rancagua rounded-lg text-white font-bold w-64 hover:bg-celeste_rancagua transition-colors duration-300 font-bold'
                >
                  CLASES <br />
                  MAGISTRALES
                </Button>
                <h6 className='mb-2 mt-2 font-semibold leading-5 text-white'>
                  De gobierno abierto
                </h6>
              </div>
            </div>
            <div className='p-8'>
              <div className='max-w-md text-center'>
                <div className='flex items-center justify-center'>
                  <img
                    src='/assets/ilustraciones/svg/talleres_de_extension.svg'
                    alt='talleres de extension'
                  />
                </div>
                <Button
                    onClick={handleClickMaster}
                  href='https://forms.gle/f6dxmfFPE1UVPgnaA'
                  target='_blank'
                  rel='noreferrer'
                  className='lg:px-14 px-2 py-4 font-medium md:-ml-0 -ml-5  transform bg-naranjo_rancagua rounded-lg text-white font-bold w-64 hover:bg-celeste_rancagua transition-colors duration-300 font-bold'
                >
                  TALLERES <br /> EXTENSIÓN
                </Button>
                <h6 className='mb-2 mt-2 font-semibold leading-5 text-white'>
                  (Huerto, origami, yoga, etc)
                </h6>
              </div>
            </div>
            <div className='p-8'>
              <div className='max-w-md text-center'>
                <div className='flex items-center justify-center'>
                  <img
                    src='/assets/ilustraciones/svg/talleres_funcionarios.svg'
                    alt='talleres funcionarios publicos'
                  />
                </div>
                <Button
                    onClick={handleClickPublic}
                  href='https://forms.gle/LCQ7R7x6eDdUG5oH7'
                  target='_blank'
                  rel='noreferrer'
                  className=' px-8 py-4 font-medium transform bg-naranjo_rancagua rounded-lg text-white  w-68 hover:bg-celeste_rancagua transition-colors duration-300 font-bold'
                >
                  TALLERES FUNCIONARIOS <br /> PÚBLICOS
                </Button>
                <h6 className='mb-2 mt-2 font-semibold leading-5 text-white'>
                  Diálogos y confianza
                </h6>
              </div>
            </div>
          </div>
          <div className='grid grid-cols-1'>
            <Button
                onClick={handleClick}
              href='https://drive.google.com/drive/folders/1CiavIXON8OsZNCxceoBvLqCxtAJTlkH6'
              target='_blank'
              rel='noreferrer'
              className='mx-auto lg:px-8 px-4 py-4 font-medium text-xl tracking-wide text-black capitalize bg-white transition-colors duration-300 transform rounded-lg mt-12 w-64 hover:bg-celeste_rancagua transition-colors duration-300'
            >
              VER PROGRAMA
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Apply
